import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import PropertiesList from './PropertiesList';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';

const PropertiesListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.properties.title') } />

                <Actions>
                    <CreateButton basePath={ resource } />
                </Actions>
            </Header>

            <PropertiesList
                { ...props }
            />
        </div>
    );
};

PropertiesListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(PropertiesListContainer);



// WEBPACK FOOTER //
// ./src/pages/properties/list/PropertiesListContainer.js